'use strict';
var base = require('./base');
var focusHelper = require('base/components/focus');
const urlHelper = require('friartux/utils/urlHelper');
const tooltip = require('friartux/components/tooltip');
const mobileWindowWidth = 543;

const SELECTORS = {
    body: 'body',
    sizeChangeBtn: '.js-size-change',
    selectCoatSize: '.select-size',
    miniProductTile: '.js-mini-plp-product-tile'
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <a class="full-pdp-link" href=""></a>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {string} purchaseOption - current purchaseOption
 */
function fillModalElement(selectedValueUrl, purchaseOption) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            $('.rent-customize.rentContainer button.add-to-cart').attr('disabled', false);

            var childOptionLength = $('.purchase-option').children().length;
            if (childOptionLength) {
                $('.purchase-option .option-btn').removeClass('shadow-none').removeClass('active');
                $('.purchase-option .option-btn')[purchaseOption && purchaseOption === 'buy' ? 'last' : 'first']()
                    .addClass('shadow-none')
                    .addClass('active');

                    if ($('.purchase-option .option-btn.active').data('value') == 'buy') {
                        $('.buyContainer').addClass('active');
                        $('.rentContainer').removeClass('active');
                    } else if ($('.purchase-option .option-btn.active').data('value') == 'rent') {
                        $('.rentContainer').addClass('active');
                        $('.buyContainer').removeClass('active');
                    }
            }

            // Disable add to cart.
            $('.buyContainer.disabled button.add-to-cart')
                .attr('disabled', true)
                .addClass('disabled');
            $('.rentContainer.disabled button.add-to-cart')
                .attr('disabled', true)
                .addClass('disabled');
            tooltip.init();

            if (window.innerWidth <= mobileWindowWidth) {
                $('#quickViewModal .modal-body')
                    .find(SELECTORS.selectCoatSize)
                    .removeClass('js-select-dropdown-below')
                    .addClass('js-select-dropdown-above');
            }

            $(SELECTORS.body).trigger('select:reInit');
            $.spinner().stop();

        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function handleShowQuickview(e, selectingSize) {
    if (e) {
        e.preventDefault();
    }

    if (typeof selectingSize === 'undefined') {
        let productTile = $(e.target).closest('.product');
        selectingSize = productTile.find('.selected-check').length !== 0;
    }

    var selectedValueUrl = $(this).closest('a.quickview').attr('href');
    if (!selectedValueUrl) {
        selectedValueUrl = $(this).data('qvhref');
    }
    if (selectedValueUrl) {
        selectedValueUrl = urlHelper.appendToUrl(selectedValueUrl, { selectingSize: selectingSize });
    }

    let selectedPid = $(e.target).parents(SELECTORS.miniProductTile).data('selected-pid');
    if (selectedPid) {
        selectedValueUrl = urlHelper.appendToUrl(selectedValueUrl, { selectedPid: selectedPid });
    }

    let purchaseOption;
    if (e) {
        $(e.target).trigger('quickview:show');

        let btn = $(e.target).hasClass('recommendation-btn') ? $(e.target) : $(e.target).closest('.recommendation-btn, .js-size-change');
        purchaseOption = btn.data('purchase-option');
    }

    getModalHtmlElement();
    fillModalElement(selectedValueUrl, purchaseOption);
}

module.exports = {
    methods: {
        handleShowQuickview: handleShowQuickview,
    },
    showQuickview: function () {
        $('body').on('click', '.quickview', handleShowQuickview)
    },
    handleBuySizeError: function () {
        $('body').on('click', SELECTORS.sizeChangeBtn, function(e) {
            e.preventDefault();

            var $trigger = $(this);
            var $productInfo = $trigger.parents('.product-info');

            // The size-change quickview always replaces a primary look item;
            // other mini-PLP flows may have left this flag set to false.
            $('.js-primary-product').val(true);

            var selectingSize = true;
            handleShowQuickview.call($productInfo, e, selectingSize);

            // Target the clicked line item for the replacement. Read by the
            // add-to-cart form build (product/base.js); scoped to this modal
            // instance, which handleShowQuickview recreates on every open.
            $('#quickViewModal')
                .data('replace-uuid', $productInfo.data('uuid'))
                .one('hidden.bs.modal', function () {
                    // Return focus to the trigger, or to its re-rendered
                    // successor when the size change replaced the card.
                    var $target = $.contains(document.documentElement, $trigger[0])
                        ? $trigger
                        : $('.js-selected-products .js-size-change').first();
                    $target.trigger('focus');
                });
        })
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );

            // Disable add to cart.
            $('.buyContainer.disabled button.add-to-cart')
                .attr('disabled', true)
                .addClass('disabled');
            $('.rentContainer.disabled button.add-to-cart')
                .attr('disabled', true)
                .addClass('disabled');
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);


            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    customizelook: base.customizelook,
    selectAttribute: base.selectAttribute,
    sizeAttribute: base.sizeAttribute
};
